export const IMPORT_SAMPLE_CASES = [
    {
      "caseAssociationName": "Account",
      "associationName": "AC0001 - Doe Industries",
      "contactName": "Jhon A Doe",
      "contactEmailAddress": "john.doe@company.com",
      "categoryName": "CRM",
      "priorityName": "Medium",
      "subject": "Account information checking",
      "ticketDesc": "Check all the related information",
      "currentStage": "New",
      "resolutionDate": "2025-01-01"
    },
    {
      "caseAssociationName": "Lead",
      "associationName": "LD0001 - Smith Consulting",
      "contactName": "Jane B Smith",
      "contactEmailAddress": "jane.smith@services.com",
      "categoryName": "CRM",
      "priorityName": "Medium",
      "subject": "Lead information checking",
      "ticketDesc": "Check all the related information",
      "currentStage": "New",
      "resolutionDate": "2024-01-01"
    },
    {
      "caseAssociationName": "Lead",
      "associationName": "LD0002 - Speaqua Sound Co.",
      "contactName": "Emily C Johnson",
      "contactEmailAddress": "emily.johnson@health.org",
      "categoryName": "CRM",
      "priorityName": "Medium",
      "subject": "Speaqua Sound Co. Lead information checking",
      "ticketDesc": "Check all the related information",
      "previousStage": null,
      "currentStage": "New",
      "stageChangedDate": null,
      "resolutionDate": "2025-01-01"
    }
];
